import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomInput from './common/CustomInput';
import axios from 'axios';
import { API_URL } from '../creds';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import Logo from "../assets/siasat-logo-2.png"

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Token refresh logic
  useEffect(() => {
    const refreshInterval = 14 * 60 * 1000; // 14 minutes in milliseconds
    let refreshTimer;

    const refreshAccessToken = async () => {
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const response = await axios.post(`${API_URL}/refresh`, { refresh_token: refreshToken });
          const { access_token, refresh_token, expires_in } = response.data;

          localStorage.setItem('access_token', access_token);
          localStorage.setItem('refresh_token', refresh_token);
          localStorage.setItem('expires_at', Date.now() + (expires_in * 1000));
        }
      } catch (err) {
        console.error('Token refresh failed:', err);
        setError('Session expired. Please login again.');
      }
    };

    const setupTokenRefresh = () => {
      const expiresAt = localStorage.getItem('expires_at');
      if (expiresAt && Date.now() < expiresAt) {
        const timeUntilRefresh = expiresAt - Date.now() - 60000; // Refresh 1 min before expiry
        refreshTimer = setTimeout(refreshAccessToken, timeUntilRefresh);
      }
    };

    setupTokenRefresh();
    refreshTimer = setInterval(refreshAccessToken, refreshInterval);

    return () => clearInterval(refreshTimer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/login`, {
        username: email,
        password: password
      });

      const { access_token, refresh_token, expires_in } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      localStorage.setItem('expires_at', Date.now() + (expires_in * 1000));

      onLogin(email, access_token);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-gray-50 border border-gray-400 rounded-2xl shadow-[0_5px_5px_rgba(146,101,202,0.5)] p-8 w-full max-w-[450px] mx-auto">
        <div className="flex flex-col items-center gap-2 mb-6">
          {/* <img src={Logo} alt="siasat-logo" /> */}
          <h1 className="text-5xl text-gray-900 font-bold">Login!</h1>
          {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <CustomInput
            label="Email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
          />
          <div className="relative">
            <CustomInput
              label="Password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-500 cursor-pointer">
              {showPassword ? <FaEyeSlash size={28} className='text-gray-900' /> : <FaEye size={28} className='text-gray-900' />}
            </span>
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="
                      text-xl 
                      group 
                      bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 
                      text-white 
                      hover:from-pink-600 hover:via-purple-600 hover:to-blue-600 
                      font-semibold 
                      py-3 
                      px-6 
                      rounded-xl 
                      shadow-lg 
                      hover:shadow-2xl 
                      transition-all 
                      duration-300 
                      flex 
                      flex-col
                      items-center 
                      justify-between
                      gap-2
                    "
          //className="mt-4 bg-blue-500 text-background font-bold py-3 rounded-lg hover:bg-blue-300 transition duration-300 disabled:opacity-50 text-xl"
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
          <div className="flex justify-between mt-2 ">
            <span className='text-gray-900'>Did you forget your password?</span>
            <a href="/forgot-password" className="hover:text-blue-300 text-blue-500">
              Reset Password?
            </a>
          </div>
          <div className="text-center mt-2 text-blue-500">
            <a href="/register" className="text-blue-500 font-bold hover:text-blue-300">
              Create Account
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

LoginForm.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default LoginForm;